// extracted by mini-css-extract-plugin
export default {"controlHeader":"contact-control-panel-heading_controlHeader__VKWba"};